import { entity, list } from "./base";

const initialEntity = {
  id: null,
  title: "",
  url: "",
  images: [""],
  maker_id: null,
  genre: "",
  genres: {
    genre_flag: 0,
    genre_id: null,
    genre_name: ""
  },
  publish_from: null,
  publish_to: null,
  for_paid_user: 1,
  published: 0,
};

export const topics = {
  namespaced: true,
  modules: {
    list: list("topics"),
    entity: entity("topics", initialEntity)
  }
};
